import { scaleLinear, scaleSqrt } from 'd3';
import type { CommonsStats } from '../lib/types';

interface Props {
  commons?: CommonsStats;
}

export function CommonsMap({ commons }: Props) {
  const promptStats = commons?.promptStats ?? [];
  const maxRounds = Math.max(1, ...promptStats.map((p) => p.rounds));
  const radius = scaleSqrt().domain([0, maxRounds]).range([18, 62]);
  const xScale = scaleLinear().domain([0, 1]).range([90, 520]);
  const yScale = scaleLinear().domain([0, 1]).range([255, 70]);

  const points = promptStats.map((item, index) => {
    const angle = (index / Math.max(1, promptStats.length)) * Math.PI * 2;
    return {
      ...item,
      x: xScale(Number.isFinite(item.avgSentPct) ? item.avgSentPct : 0.5) + Math.cos(angle) * 18,
      y: yScale(Number.isFinite(item.avgReturnPct) ? item.avgReturnPct : 0.5) + Math.sin(angle) * 18,
      r: radius(item.rounds)
    };
  });

  return (
    <div className="commons-map" role="img" aria-label="Trust commons map showing sent trust versus returned trust by prompt">
      <svg viewBox="0 0 620 330">
        <defs>
          <radialGradient id="nodeGlow" cx="35%" cy="30%" r="75%">
            <stop offset="0" stopColor="#ffffff" stopOpacity="0.95" />
            <stop offset="0.4" stopColor="#a6fff2" stopOpacity="0.86" />
            <stop offset="1" stopColor="#b99cff" stopOpacity="0.38" />
          </radialGradient>
        </defs>
        <line x1="80" y1="260" x2="550" y2="260" stroke="rgba(238,242,255,.24)" />
        <line x1="80" y1="260" x2="80" y2="60" stroke="rgba(238,242,255,.24)" />
        <text x="82" y="292" fill="#aab6df" fontSize="13">trust extended →</text>
        <text x="22" y="72" fill="#aab6df" fontSize="13" transform="rotate(-90 22 72)">reciprocity returned →</text>
        <line x1="80" y1="260" x2="550" y2="60" stroke="rgba(166,255,242,.26)" strokeDasharray="8 8" />
        {points.length === 0 ? (
          <text x="310" y="170" textAnchor="middle" fill="#aab6df">The commons is waiting for its first human signal.</text>
        ) : null}
        {points.map((point) => (
          <g key={point.promptId}>
            <circle cx={point.x} cy={point.y} r={point.r} fill="url(#nodeGlow)" opacity="0.78" />
            <circle cx={point.x} cy={point.y} r={point.r + 6} fill="none" stroke="rgba(166,255,242,.16)" />
            <text x={point.x} y={point.y + 4} textAnchor="middle" fill="#101427" fontWeight="800" fontSize="12">{point.rounds}</text>
            <text x={point.x} y={point.y + point.r + 22} textAnchor="middle" fill="#eef2ff" fontSize="12">{point.promptId}</text>
          </g>
        ))}
      </svg>
    </div>
  );
}
